
class LegacyDecorator {
  hasPermission (user, ...validPermissions) {
    console.debug('Checking legacyPermissions')
    const finalValidPermissions = ['MASTER', ...validPermissions]
    return finalValidPermissions.includes(user.permission)
  }
}

export default new LegacyDecorator()
